import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-shopping-cart-check',
  standalone: true,
  templateUrl: '../../assets/shopping-cart-check.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamShoppingCartCheckIcon {}
